import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  userId: '',
  details: {}
}

const profileSlice = createSlice({
  name: 'profile',
  initialState: initialState,
  reducers: {
    fetchProfileFullfilled: (state, action) => {
      const { userId, ...details } = action.payload
      state.userId = userId
      state.loading = false
      state.details = details
    }
  },
  extraReducers (builder) {}
})

export const selectProfileDetails = state => state.profile.details
export const selectCertification = state => state.profile.details.certifications
export const selectTrainingHistory = state =>
  state.profile.details.trainingHistory
export const selectSkills = state => state.profile.details.skills
export const selectCurrentProjects = state =>
  state.profile.details.currentProjects

export const { fetchProfileFullfilled } = profileSlice.actions
export default profileSlice.reducer
